import React, { ReactElement } from 'react';
import { ButtonInterface } from './button.interface';
import getButtonClasses from 'atomic/utilization/button/button.helper';

const Button: React.FC<ButtonInterface> = ({
    style,
    tag = 'button',
    ariaLabel,
    className,
    size = 'md',
    color,
    outline = false,
    block = false,
    uppercase = false,
    weight = '500',
    type = 'button',
    onClick,
    noWrap,
    disabled,
    children
}): ReactElement => {
    const classes = getButtonClasses({ color, block, uppercase, outline, size, weight, noWrap, disabled });

    return React.createElement(tag, {
        'type': tag === 'button' ? type : void 0,
        onClick,
        'className': `${classes} ${className || ''}`,
        'aria-label': ariaLabel,
        disabled,
        style
    }, children);
};

export default Button;
